import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import getItemAvailabilityUniqId from '../../../../helpers/getItemAvailabilityUniqId';
import { paginationSuccessHandler } from '../../../../helpers/reducerPaginationHandler';
import {
  fetchInventoryItemAvailability,
  fetchInventoryItemsAvailability,
  deleteInventoryItemAvailability
} from '../../sagas/routines';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import deleteAvailabilityHandler from '../../../../helpers/deleteAvailabilityHandler';
import { clearInventoryItemsAvailability } from '../../actions';
import {
  inventoryItemsAvailabilityOnChangePage,
  inventoryItemsAvailabilityOnChangeOrder
} from '../../actions/item';

const initialState = {
  byUniqId: {},
  byItemId: {},
  fetched: false,
  fetching: false,
  fetchingError: null,
  fetchingByItem: false,
  fetchingByItemError: false,
  deleting: false,
  deleted: false,
  byUniqPagination: paginationState(),
  order: 'lastUpdated:desc'
};

export const fetchItemAvailabilityHandler = routine => ({
  [routine.TRIGGER]: set('fetchingByItem', true),
  [routine.SUCCESS]: (state, { payload: { id, response } }) => ({
    ...state,
    byItemId: set(id, response.items, state.byItemId)
  }),
  [routine.FAILURE]: (state, { error }) =>
    set('fetchingByItemError', error, state),
  [routine.FULFILL]: set('fetchingByItem', false)
});

export const fetchItemsAvailabilityHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    byUniqId: {
      ...state.byUniqId,
      ...keyBy(getItemAvailabilityUniqId, response.items)
    },
    byUniqPagination: paginationSuccessHandler(
      state.byUniqPagination,
      response,
      getItemAvailabilityUniqId
    )
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const clearInventoryItemsAvailabilityHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    byUniqId: {},
    byItemId: {},
    fetched: false,
    byUniqPagination: resetPaginationState(state.byUniqPagination)
  })
});

const updateInventoryItemsAvailabilityCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('byUniqPagination.currentPage', page, state)
});

const updateInventoryItemsAvailabilityOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...fetchItemAvailabilityHandler(fetchInventoryItemAvailability),
  ...fetchItemsAvailabilityHandler(fetchInventoryItemsAvailability),
  ...deleteAvailabilityHandler(deleteInventoryItemAvailability),
  ...clearInventoryItemsAvailabilityHandler(clearInventoryItemsAvailability),
  ...updateInventoryItemsAvailabilityCurrentPageHandler(
    inventoryItemsAvailabilityOnChangePage
  ),
  ...updateInventoryItemsAvailabilityOnChangeOrderHandler(
    inventoryItemsAvailabilityOnChangeOrder
  )
});
